import KeyStoneImage from '../../images/keystone.png';
import KeyStoneInterior from '../../images/keystone_interior.png';

export default function KeystoneSite() {
  const style = {
    color: 'black',
    backgroundColor: '#F6F6FF',
    height: '100vh',
    fontFamily: 'Times New Roman, serif',
    padding: '20px',
    overflow: 'scroll',
  };

  return (
    <div style={style}>
      <h1 style={{ margin: 0 }}>Concert at Keystone </h1>
      <p>
        <b>Tuesday, July 29th, 2025</b>
        <br />
        <i>5019 Keystone Pl N</i>
        <br />
        <i>Doors at 7, Show at 8</i>
      </p>

      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          marginBottom: '20px',
          gap: '20px',
          flexWrap: 'wrap',
        }}
      >
        <img
          src={KeyStoneImage}
          alt="Keystone Church"
          style={{
            width: '320px',
            height: 'auto',
            marginBottom: 0,
            flexShrink: 0,
            borderRadius: '8px',
          }}
        />

        <div style={{ flex: 1, minWidth: '350px' }}>
          <p>
            NYC-based band Nett is joined by Enfield for an intimate gathering
            at Keystone Church in the "Tangle Town" neighborhood of Seattle. The
            event is a fundraiser for{' '}
            <a href="https://waisn.org" target="_blank">
              Washington Immigrants Solidarity Network.
            </a>
          </p>
          <p>
            <b>
              <i>
                <a href="https://net.nyc" target="_blank">
                  Nett
                </a>
              </i>
            </b>{' '}
            is an experimental rock band. Their songs range from sparse,
            atmospheric shoegaze soundscapes (Duster) to energetic Post-punk
            riffs and odd time signatures (Squid). Their sound weaves together
            melodic, harmony- driven vocals, distinct impressionist lyrics, and
            ambient synth lines that seamlessly evoke nostalgia for Y2K
            aesthetics. Nett's performance at Keystone will be a semi-acoustic,
            semi-improvised medley of their latest work.
          </p>
          <iframe
            style={{ border: 0, width: '100%', height: '42px' }}
            src="https://bandcamp.com/EmbeddedPlayer/track=4282717451/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/"
            seamless
          >
            <a href="https://nettnyc.bandcamp.com/track/spare-parts">
              Spare Parts by Nett
            </a>
          </iframe>

          <p>
            "Seattle based{' '}
            <b>
              <i>
                <a href="https://kingrules.online/4/" target="_blank">
                  Enfield
                </a>
              </i>
            </b>{' '}
            is both familiar and strange, like an old memory somehow still full
            of new surprises. It’s stripped-down, yet oddly lush, with melodies
            that unfold in unexpected ways, just enough to make everything feel
            both weightless and important."
          </p>
        </div>
      </div>
      <section>
        <h2>Tickets</h2>
        <p>
          Admission for the concert is sliding scale $10-$20, with all proceeds
          going to the Washington Immigrants Solidarity Network.
        </p>
        <p>
          To purchase a ticket you can send a venmo payment to{' '}
          <a
            href="https://venmo.com/u/jpcarrick"
            target="_blank"
            rel="noopener noreferrer"
          >
            Nett directly
          </a>{' '}
          with the note "Nett Concert". You can also make a{' '}
          <a
            href="https://secure.lglforms.com/form_engine/s/lu3TBVHZwCuUW7O55n-n1w"
            target="_blank"
          >
            WAISN donation directly
          </a>{' '}
          and use the receipt to claim your ticket at the door.
        </p>
      </section>
      <section>
        <h2>Directions</h2>
        <p>
          Keystone Church is located at <i><b>5019 Keystone Pl N, Seattle, WA 98103.</b></i>
        </p>
        <p>
          The venue is accessible by public transportation and has plenty of street
          parking available.
        </p>
        <img
          src={KeyStoneInterior}
          alt="Keystone Church Interior"
          style={{
            width: '320px',
            height: 'auto',
          }}
        />
        <br />
        <br />
        ~
        <br />
        ~
        <br />
        ~
        <br />
        ~
        <br />
        ~
        <br />
      </section>
    </div>
  );
}
